import { TKey, useIntl } from '@weenat/wintl'
import useToasts from 'app/src/hooks/useToasts'
import copy from 'copy-to-clipboard'
import { isNil } from 'lodash-es'
import Icons from './Icons'
import Link from './LinkComponent'
import Text, { TextProps } from './Text'
import TextTooltip from './tooltips/TextTooltip'

type Variant = 'text' | 'icon' | 'text+icon'

interface CopyToClipBoardProps {
  textToCopy: string
  actionMessageKey?: TKey
  actionMessage?: string
  successMessageKey: TKey
  variant?: Variant
  textProps?: TextProps
}

const CopyToClipBoard: FC<CopyToClipBoardProps> = ({
  textToCopy,
  actionMessageKey,
  actionMessage,
  successMessageKey,
  variant = 'text',
  textProps
}) => {
  const { t } = useIntl()
  const { addSuccessToast } = useToasts()

  const handleCopy = () => {
    copy(textToCopy)
    addSuccessToast(t(successMessageKey))
  }

  const displayedText = !isNil(actionMessageKey)
    ? t(actionMessageKey)
    : !isNil(actionMessage)
      ? actionMessage
      : null

  return variant === 'text' ? (
    <Link $underlined onPress={handleCopy} {...textProps}>
      {displayedText}
    </Link>
  ) : variant === 'text+icon' ? (
    <Flex $alignItems='center' onClick={handleCopy} $cursor='pointer' $gap='sm'>
      <Text $underlined $fontWeight='bold' {...textProps}>
        {displayedText}
      </Text>
      <Icons.Copy $size='lg' />
    </Flex>
  ) : (
    <TextTooltip content={t('models.invitation.misc.copy_invitation_link')}>
      <Icons.Copy $size='lg' onPress={handleCopy} />
    </TextTooltip>
  )
}

export default CopyToClipBoard
